import { ListWithSpeech } from 'components/common/CollectionWrappersWithSpeech';
import { Lightning } from '@lightningjs/sdk';

export class ExpandableList extends ListWithSpeech {
  private _isHovered = false;

  override _focus(newFocusedComponent: any, prevFocusedComponent: any) {
    super._focus(newFocusedComponent, prevFocusedComponent);

    this.signal('onListFocus', this.index);
  }

  _handleHover(target: Lightning.Element) {
    this.isHovered = true;
    this.signal('$onHover', this);
    return false;
  }

  _handleUnhover(target: Lightning.Element) {
    this.isHovered = false;
    this.signal('$onUnHover', this);
    return false;
  }

  set isHovered(flag: boolean) {
    this._isHovered = flag;
  }

  get isHovered() {
    return this._isHovered;
  }
}
